import jQuery from 'jquery';
import PropTypes from 'prop-types';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import './TopBar.css';

const tooltip = (text) => {
    return (
        <Tooltip id={text}>{text}</Tooltip>
    );
};

class SocialElement extends React.Component {
    render() {
        return (
            <li>
                <a className={this.props.className} title={this.props.title} href={this.props.link} target="_blank">
                    <OverlayTrigger placement={'bottom'} overlay={tooltip(this.props.title)}>
                        <i className={this.props.icon}></i>
                    </OverlayTrigger>
                </a>
            </li>
        );
    }
}

SocialElement.propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired
};

export default class TopBar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll() {
        if (window.scrollY > 50) {
            jQuery('.top-bar').slideUp(300);
            jQuery('header').addClass('fixed-header');
            jQuery('.navbar-brand').css({ 'padding-top': 3 + 'px', 'padding-bottom': 0 + 'px' });

            if (/iPhone|iPod|BlackBerry/i.test(navigator.userAgent) || jQuery(window).width() < 479) {
                jQuery('.navbar-default .navbar-nav > li > a').css({
                    'padding-top': 0 + 'px',
                    'padding-bottom': 0 + 'px'
                });
            } else {
                jQuery('.navbar-default .navbar-nav > li > a').css({
                    'padding-top': 20 + 'px',
                    'padding-bottom': 20 + 'px'
                });
                jQuery('.search-side').css({ 'margin-top': -7 + 'px' });
            }

        } else {
            jQuery('.top-bar').slideDown(300);
            jQuery('header').removeClass('fixed-header');
            jQuery('.navbar-brand').css({ 'padding-top': 10 + 'px', 'padding-bottom': 10 + 'px' });

            if (/iPhone|iPod|BlackBerry/i.test(navigator.userAgent) || jQuery(window).width() < 479) {
                jQuery('.navbar-default .navbar-nav > li > a').css({
                    'padding-top': 0 + 'px',
                    'padding-bottom': 0 + 'px'
                });
            } else {
                jQuery('.navbar-default .navbar-nav > li > a').css({
                    'padding-top': 28 + 'px',
                    'padding-bottom': 28 + 'px'
                });
                jQuery('.search-side').css({ 'margin-top': 0 + 'px' });
            }

        }
    }

    render() {
        return (
            <div className="top-bar">
                <div className="container">
                    <div className="row">
                        <div className="col-md-10">
                            <ul className="contact-details">
                                <li>
                                    <span><i className="fa fa-home"></i></span>
                                    4 rue de l’herminette – 85300 SALLERTAINE
                                </li>
                                <li>
                                    <span><i className="fa fa-phone"></i></span>
                                    +33 (0)2 85 29 24 24
                                </li>
                                <li>
                                    <span><i className="fa fa-clock-o"></i></span>Lun. Ven. 8h30-19h00 Sam. 8h30-13h00
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-2">
                            <ul className="social-list">
                                <SocialElement
                                    title={'Linkedin'}
                                    icon={'icon-linkedin'}
                                    className={'linkdin'}
                                    link={'https://www.linkedin.com/in/stapmedif-op%C3%A9rateur-de-service-pour-professionnels-de-sant%C3%A9/'}
                                />
                                <SocialElement
                                    title={'Twitter'}
                                    icon={'icon-twitter-2'}
                                    className={'twitter'}
                                    link={'https://twitter.com/stapmedif'}
                                />
                                <SocialElement
                                    title={'Facebook'}
                                    icon={'icon-facebook-2'}
                                    className={'facebook'}
                                    link={'https://www.facebook.com/Stapmedif-355924515306119/'}
                                />
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/TopBar.jsx